import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { GridActionsCellItem } from '@mui/x-data-grid';
import { useWatch } from 'react-hook-form';

import { useDisclosure } from '@hooks/useDisclosure';
import { useGreenhouseForm } from '@Router/EsgGreenhouse/Containers/EsgGreenhouseFormProvider';
import ModalSubcommittees from '../ModalSubcommittees/ModalSubcommittees';
import { SubcommitteeActionsProps } from './SubcommitteeActions';

const SubcommitteeEditButton = ({ rowId }: SubcommitteeActionsProps) => {
  const [opened, { open, close }] = useDisclosure();
  const { getValues } = useGreenhouseForm();

  const { completedSection } = useWatch({
    name: 'climateChangeStructure',
  });
  const { isCompletedTh, isCompletedEn } = completedSection ?? {};
  const isNewDetails = typeof rowId === 'string';

  const subcommittee =
    getValues().climateChangeStructure?.subcommitteeResponsibility
      .subcommittees ?? [];

  const currentIndex = isNewDetails
    ? Number(rowId.replace('NEW-', '')) - 1
    : subcommittee.findIndex((detail) => detail.id === rowId);

  const editData = subcommittee[currentIndex];

  return (
    <>
      <GridActionsCellItem
        key="edit"
        icon={<EditOutlinedIcon style={{ fontSize: '16px' }} />}
        label="Edit"
        onClick={open}
        disabled={isCompletedTh && isCompletedEn}
      />
      {opened && (
        <ModalSubcommittees
          mode="edit"
          open={opened}
          close={close}
          rowId={currentIndex}
          editData={editData}
        />
      )}
    </>
  );
};

export default SubcommitteeEditButton;
